
window.WP_Grid_Builder && WP_Grid_Builder.on('init', function (wpgb) {

  wpgb.facets.on( 'render', function( element, facet ) {
    if(facet.slug == 'load_more') {

      setTimeout(() => {
        const results = facet.holder.parentNode.parentNode.parentNode.previousElementSibling;
        const currentNumber = results.querySelectorAll(':scope > *:not([data-no-result])').length;
        let remainingPosts = 0;

        if(facet.html) {
          remainingPosts = facet.html.match(/\d+/)[0];
        }

        const totalNumber = parseFloat(currentNumber) + parseFloat(remainingPosts);

        const controlsFooter = facet.holder.parentNode.parentNode.parentNode.querySelector('.c-article__controls--footer')
        const controlCurrentCount = controlsFooter.querySelector('[data-current-count]');
        const controlMaxCount = controlsFooter.querySelector('[data-max-count]');


        controlCurrentCount.innerText = currentNumber;
        controlMaxCount.innerText = totalNumber;
        if(totalNumber < 1 || currentNumber === totalNumber) {
          controlsFooter.style.display = 'none';
        } else {
          controlsFooter.style.display = '';
        }

        controlsFooter.querySelector('.c-progress').style.setProperty('--load-more-progress', `${currentNumber / totalNumber * 100}%`)
      },250)

    }

    wpgb.facets.on( 'change', function( slug, values ) {

      // Scroll to grid after search query
      if ( slug.includes('search')) {
        // prevent layout hop

        const hideAbleWidgets = document.querySelectorAll('.c-widget--hide-on-search');

        setTimeout(() => {
          const inputElm = document.querySelector('[name="'+slug+'"]');
          if(inputElm) {

            const inputWrapper = inputElm.closest('.wpgb-facet');
            const grid = inputWrapper.dataset.grid;

            if (inputElm.value) {

              hideAbleWidgets.forEach(widget => {
                widget.style.display = 'none';
              });

              if (grid) {

                const gridEl = document.querySelector('.wpgb-grid-' + grid);
                const offsetTop = gridEl.offsetTop;

                gridEl.classList.remove('c-filtergrid');
                if (offsetTop) {
                  scroll({
                    top: offsetTop - 150,
                    behavior: "smooth"
                  });
                }
              }

            } else {
              hideAbleWidgets.forEach(widget => {
                widget.style.display = '';
              });

              if (grid) {
                const gridEl = document.querySelector('.wpgb-grid-' + grid);
                gridEl.classList.add('c-filtergrid');
              }
            }

          }
        },250)

      }

    } );

  } );
});
